module.exports = __webpack_public_path__ + "static/media/ps2.ffdca23d.jpg";